import React from 'react';
import { Link } from 'react-router-dom';
import privacyBanner from '../images/privacy-policy-banner.jpg';
import './Policies.css';

const Policies = () => {
  const policies = [
    {
      name: 'Anti Money Laundering Policy',
      path: '/policies/anti-money-laundering',
      icon: '📄'
    },
    {
      name: 'Privacy Policy',
      path: '/privacy',
      icon: '📄'
    },
    {
      name: 'Fair Practice Code',
      path: '/policies/fair-practice-code',
      icon: '📄'
    }
  ];

  return (
    <div className="policies-page">
      {/* Banner Section */}
      <section className="policies-banner">
        <div className="policies-banner-wrapper">
          <div className="banner-image" style={{ backgroundImage: `url(${privacyBanner})` }}>
            <div className="banner-overlay">
              <h1 className="banner-heading">AMPIRE FINANCE</h1>
            </div>
          </div>
          <div className="banner-content">
            <h2 className="banner-title">POLICIES</h2>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="policies-content">
        <div className="policies-wrapper">
          <div className="policies-list">
            {policies.map((policy, index) => (
              <Link key={index} to={policy.path} className="policy-item policy-cta">
                <div className="policy-icon">{policy.icon}</div>
                <div className="policy-name">{policy.name}</div>
                <div className="policy-arrow">↗</div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Policies;




